// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PartConfigSuspension } from './part-config-suspension';
import { PartConfigTire } from './part-config-tire';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PartConfigSuspensionTireLink extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  displayOrder?: number;
  partConfigSuspensionId!: number;
  partConfigTireId!: number;
  partConfigSuspension!: PartConfigSuspension;
  partConfigTire!: PartConfigTire;
}

